import * as _ from 'lodash';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class UserListService {
    public list: WritableSignal<any[]> = signal([]);

    constructor(
      private http: HttpClient,
      private cookieService: CookieService,
    ) {}

    getUserList() {
      const token = this.cookieService.get('accessToken');
      return this.http.post('/api/getOrgAccounts', `access_token=${token}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
}
